import { StyledPartnerCard } from '../../../../Organisms/PartnerCard/styles'
import { styled } from '../../../../Styles/stitches.config'
import { StyledGrid } from '../../../Grid/styles'

export const StyledPartnerCardLoader = styled(StyledPartnerCard, {
    [`& ${StyledGrid}`]: {
        w: '100%',

        '@desktop': {
            justifyItems: 'center',
            maxW: 150,
        },
    },
})
